module.exports = __webpack_public_path__ + "static/media/targeting_en.a5c562bd.png";